"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LogLevel = void 0;
/**
 * The verbosity level of a log entry
 */
var LogLevel;
(function (LogLevel) {
    /**
     * Verbose is the noisiest level, rarely (if ever) enabled for a production app.
     */
    LogLevel[LogLevel["Verbose"] = 0] = "Verbose";
    /**
     * Debug is used for internal system events that are not necessarily observable from the outside, but useful when determining how something happened.
     */
    LogLevel[LogLevel["Debug"] = 1] = "Debug";
    /**
     * Information events describe things happening in the system that correspond to its responsibilities and functions. Generally these are the observable actions the system can perform.
     */
    LogLevel[LogLevel["Information"] = 2] = "Information";
    /**
     * When service is degraded, endangered, or may be behaving outside of its expected parameters, Warning level events are used.
     */
    LogLevel[LogLevel["Warning"] = 3] = "Warning";
    /**
     * When functionality is unavailable or expectations broken, an Error event is used.
     */
    LogLevel[LogLevel["Error"] = 4] = "Error";
    /**
     * The most critical level, Fatal events demand immediate attention.
     */
    LogLevel[LogLevel["Fatal"] = 5] = "Fatal";
})(LogLevel = exports.LogLevel || (exports.LogLevel = {}));
//# sourceMappingURL=log-entries.js.map